import InitialValue from "./initialValue";
import { createContext } from "react";

const GeneralContext = createContext(InitialValue.general);

export default GeneralContext;
